import { Box, CircularProgress, IconButton, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import convertSize from 'convert-size';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';
import FileExtIcon from './FileExtIcon';

const UploadProgressWidget = () => {
    const { t } = useTranslation();
    const { uploads } = useAuth();

    if (!uploads?.length) return null;

    return (
        <Box sx={{
                position: 'fixed', bottom: '16px', right: '16px', zIndex: 1400,
                display: 'flex', flexDirection: 'column', gap: '8px', width: '300px', maxWidth: 'calc(100vw - 32px)',
            }}>
            {uploads.map((upload) => (
                <Paper key={upload.id} elevation={4} className="d-flex flex-row align-items-center p-2 rounded-2" sx={{ gap: '10px' }}>
                    <Box sx={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
                        <CircularProgress variant="determinate" value={upload.progress} size={40} thickness={4}/>
                        <Box sx={{
                                top: 0, left: 0, bottom: 0, right: 0, position: 'absolute',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                            <Typography component="span" className="font-10 bold fg-dark">{upload.progress}%</Typography>
                        </Box>
                    </Box>
                    <div className="flex-shrink-0">
                        <FileExtIcon extension={upload.extension} width="24px"/>
                    </div>
                    <div className="d-flex flex-column flex-fill overflow-hidden">
                        <span className="font-13 fg-dark text-truncate" title={upload.name}>
                            {upload.name}{upload.extraCount > 0 ? ` +${upload.extraCount}` : ''}
                        </span>
                        <span className="small text-muted">
                            {convertSize(upload.size, { accuracy: 2 })} · {t('UPLOADING')}
                        </span>
                    </div>
                    <IconButton size="small" onClick={() => upload.controller.abort()} title={t('CANCEL')}>
                        <CloseIcon className="font-16"/>
                    </IconButton>
                </Paper>
            ))}
        </Box>
    );
}

export default UploadProgressWidget;
